import turfFn from "@turf/boolean-point-in-polygon";

export default function booleanPointInPolygon(coord, poly, options) {
    return turfFn(coord, poly, options);
}
